module.exports = __webpack_public_path__ + "static/img/homebg.37ee61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homebg.png
// module id = +6qt
// module chunks = 19